// 将后端返回的相对路径（uploads/...）拼成完整资源地址用于显示；
// 绝对地址（http/https）以及 blob/data 等直接原样返回。
export function resolveLogoUrl(logoImg, baseUrl) {
  if (logoImg && typeof logoImg === 'string') {
    if (/^https?:\/\//i.test(logoImg) || /^(blob|data):/i.test(logoImg)) {
      return logoImg;
    }
    const base = (baseUrl || '').replace(/\/+$/, '');
    return base ? `${base}/${logoImg.replace(/^\//, '')}` : logoImg;
  }
  return logoImg;
}

// localStorage 缓存 key 前缀（仅对相对路径 logo 做浏览器缓存，避免每次刷新重新请求图片）
const CACHE_PREFIX = 'cardLogoCache:';

// 获取 logo 的显示 URL，优先使用 localStorage 中的 dataURL 缓存（仅相对路径）
// 首次加载返回 fresh URL 并在后台异步 fetch 转 dataURL 写入 localStorage，
// 下次刷新直接用 dataURL 渲染（dataURL 不走网络，零请求）
export function getLogoWithCache(logoRaw, baseUrl) {
  if (!logoRaw || typeof logoRaw !== 'string') return logoRaw || '';
  // 完整 URL（http/https）或 data/blob：直接返回，不缓存（跨域 fetch 易被 CORS 阻止）
  if (/^https?:\/\//i.test(logoRaw) || /^(blob|data):/i.test(logoRaw)) {
    return logoRaw;
  }
  const cacheKey = CACHE_PREFIX + logoRaw;
  try {
    const cached = localStorage.getItem(cacheKey);
    if (cached) return cached;
  } catch (e) {
    // localStorage 不可用时回退到 fresh URL
  }
  // 没有缓存：用 fresh URL，并后台异步缓存（不阻塞渲染）
  const freshUrl = resolveLogoUrl(logoRaw, baseUrl);
  prefetchLogoToCache(freshUrl, cacheKey);
  return freshUrl;
}

// 后台将图片转为 dataURL 写入 localStorage（失败静默，不影响当前显示）
function prefetchLogoToCache(url, key) {
  if (typeof fetch === 'undefined') return;
  fetch(url)
    .then((r) => { if (!r.ok) throw new Error('status ' + r.status); return r.blob(); })
    .then((blob) => new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = () => {
        try { localStorage.setItem(key, reader.result); } catch (e) { /* 容量满或被禁用，忽略 */ }
        resolve();
      };
      reader.onerror = () => resolve();
      reader.readAsDataURL(blob);
    }))
    .catch(() => { /* 静默失败 */ });
}
